import { downloadFileWithLink } from '_helpers/common';
import { transferService } from '_services';
import alertActions from './alert.actions';

const downloadMachineConfiguration = (machineID, datetime) => async (dispatch) => {
  try {
    return await transferService.downloadConfig(machineID, datetime);
  } catch (e) {
    dispatch(alertActions.error('Error downloading config.', e));
  }
  return null;
};

const downloadMachineDatagram = (machineID, datetime) => async (dispatch) => {
  try {
    return await transferService.downloadDatagram(machineID, datetime);
  } catch (e) {
    dispatch(alertActions.error('Error downloading datagram.', e));
  }
  return null;
};

const downloadLicense = (machineID) => async (dispatch) => {
  try {
    return await transferService.downloadLicense(machineID);
  } catch (e) {
    dispatch(alertActions.error('Error downloading license.', e));
  }
  return null;
};

const downloadLicenseDatagram = (machineID) => async (dispatch) => {
  try {
    return await transferService.downloadLicenseDatagram(machineID);
  } catch (e) {
    dispatch(alertActions.error('Error downloading license datagram.', e));
  }
  return null;
};

const uploadLicenseEnvelope = (licenseFile) => async (dispatch) => {
  try {
    return await transferService.uploadLicenseEnvelope(licenseFile);
  } catch (e) {
    dispatch(alertActions.error('Error uploading license.', e));
  }
  return null;
};

const uploadConfig = (machineID, configFile) => async (dispatch) => {
  try {
    return await transferService.uploadConfig(machineID, configFile);
  } catch (e) {
    dispatch(alertActions.error('Error uploading config.', e));
  }
  return null;
};

const downloadMinePlan = (minePlanID) => async (dispatch) => {
  try {
    const response = await transferService.getMinePlanFileLink(minePlanID);

    if (response?.fileLink) {
      downloadFileWithLink(response.fileLink);
      dispatch(alertActions.success('Mineplan file download started.'));
    } else {
      dispatch(alertActions.error('Failed to download mineplan.'));
    }
  } catch (e) {
    dispatch(alertActions.error('Error downloading mineplan.', e));
  }
  return null;
};

const transferActions = {
  downloadMachineConfiguration,
  downloadMachineDatagram,
  downloadLicense,
  downloadLicenseDatagram,
  uploadLicenseEnvelope,
  uploadConfig,
  downloadMinePlan
};

export default transferActions;
